<template>
  <div>
    <a-modal v-model:visible="visible" title="关联症候群" @ok="handleOk" okText="确认" cancelText="取消" :afterClose="closeModal">
      <a-form :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item label="名称">
          <syndromeSelector v-model="formState.name" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { AddRelation } from "/src/api/syndrome.js";
import syndromeSelector from '/src/components/selector/syndromeSelector.vue';

export default {
  components: {
    syndromeSelector,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    record: {
      type: Object,
      default: () => ({}) 
    },
  },
  emits: ['update:modelValue', 'reload'],
  data() {
    return {
      visible: this.modelValue,
      reload: false,
      formState: {
        name: undefined, 
      },
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
    };
  },
  watch: {
    modelValue(val) {
      this.visible = val;
    },
  },
  methods: {
    async handleOk() {
      if (!this.formState.name) {
        this.$message.warning("请选择需要关联的症候群");
        return;
      }

      const syndromeList = this.$store.state.syndromeList || [];
      const parentSyndrome = syndromeList.find(item => item.name === this.formState.name);
      
      if (!parentSyndrome) {
        this.$message.warning("未找到匹配的症候群数据");
        return;
      }

      const parentId = parentSyndrome.id;

      if (this.record.id === parentId) {
        this.$message.warning("不能关联自身");
        return;
      }

      // 4. 发起请求
      let res = await AddRelation({ id: this.record.id, parentId });
      if (res.errCode === 0) {
        this.$message.success("关联成功");
        this.visible = false;
        this.reload = true;
        this.formState.name = undefined; // 成功后重置表单
      } else {
        this.$message.error(res.errMsg || "关联失败");
      }
    },
    closeModal() {
      this.$emit('update:modelValue', false);
      if (this.reload) {
        this.$emit("reload");
        this.reload = false; 
      }
    },
  },
};
</script>

<style scoped>
</style>